import { Box, Divider } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

import { formatCompactNumber, sortObjectArray } from '../../../../utils';

import { Heading2, Heading3, Heading4 } from '../../../../components/Heading';
import S3Avatar from '../../../../components/S3Avatar';
import NumberMark from '../../../../components/NumberMark';

const GymLeaderboards = ({ hightLight, title, data, type }) => {
  const sortedData = sortObjectArray(data, 'value', 'desc');

  return (
    <Box>
      <Heading3>{title}</Heading3>
      <Box mt={{ xs: 3, tl: 4, lg: 7 }}>
        {sortedData.map((obj, index) => (
          <React.Fragment key={index}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mt={3}
              pl={{ xs: 2, lg: 0 }}
            >
              <Box display="flex" alignItems="center">
                <Box
                  position="relative"
                  width={
                    index === 0 ? (hightLight ? { xs: 128, tl: 248 } : { xs: 88, tl: 96 }) : 64
                  }
                  height={
                    index === 0 ? (hightLight ? { xs: 128, tl: 248 } : { xs: 88, tl: 96 }) : 64
                  }
                >
                  <NumberMark number={index + 1} />
                  <Link to={`/${type}/${obj.name}`}>
                    <Box
                      sx={{
                        width: '100%',
                        height: '100%',
                        padding: '1px',
                        background:
                          index === 0
                            ? 'linear-gradient(180deg, #925F01 0%, #C3A128 30%, #FEF89D 40%, #F4CE02 80%)'
                            : '#313131',
                      }}
                    >
                      <S3Avatar src={obj.image} />
                    </Box>
                  </Link>
                </Box>
                {!(index === 0 && hightLight) && (
                  <Link to={`/${type}/${obj.name}`}>
                    <Heading4 sx={{ ml: index === 0 ? 2 : 3, wordBreak: 'break-all' }}>
                      {obj.name}
                    </Heading4>
                  </Link>
                )}
              </Box>
              <Box flex={index === 0 && hightLight ? 1 : 0} ml={index === 0 && hightLight ? 3 : 0}>
                {index === 0 && hightLight && (
                  <Link to={`/${type}/${obj.name}`}>
                    <Heading3 sx={{ ml: 1, mb: 2, wordBreak: 'break-all' }}>{obj.name}</Heading3>
                  </Link>
                )}
                <Heading2
                  sx={{ ml: 1, ...(index === 0 && hightLight && { fontSize: { xs: 40, tl: 80 } }) }}
                >
                  {formatCompactNumber(obj.value)}
                </Heading2>
              </Box>
            </Box>
            {index !== sortedData.length - 1 && (
              <Box display="flex" justifyContent="flex-end">
                <Divider
                  sx={{
                    borderColor: '#B1B1B1',
                    mt: 2,
                    width: { xs: '100%', tl: 'calc(100% - 88px)' },
                  }}
                />
              </Box>
            )}
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
};

export default GymLeaderboards;
